module.exports = __webpack_public_path__ + "img/cockpit_blaupause_dark.dfebefb8.gif";